import React, { useEffect, useRef, useState } from 'react';
import { useMotion } from '../../context/MotionContext';

const ScrambleText = ({ 
  text, 
  className = '', 
  delay = 0,
  duration = 350
}) => {
  const textRef = useRef(null);
  const [displayText, setDisplayText] = useState(text);
  const [isVisible, setIsVisible] = useState(false);
  const { prefersReducedMotion } = useMotion();
  
  useEffect(() => {
    if (prefersReducedMotion) {
      setDisplayText(text);
      return;
    }
    
    const element = textRef.current;
    if (!element) return;
    
    let intervalId = null;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          
          const chars = text.split('');
          const scrambleChars = '!<>-_\\/[]{}—=+*^?#________';
          let frame = 0;
          const totalFrames = Math.floor(duration / 16); // ~60fps
          
          intervalId = setInterval(() => {
            if (frame >= totalFrames) {
              setDisplayText(text);
              clearInterval(intervalId);
              return;
            }
            
            const progress = frame / totalFrames;
            const decoded = chars.map((char, index) => {
              if (index / chars.length < progress) {
                return char;
              }
              return scrambleChars[Math.floor(Math.random() * scrambleChars.length)];
            }).join('');
            
            setDisplayText(decoded);
            frame++;
          }, 16);
        }
      },
      { threshold: 0.1 }
    );
    
    if (element) {
      observer.observe(element);
    }
    
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [text, duration, isVisible, prefersReducedMotion]);
  
  return (
    <span ref={textRef} className={className}>
      {displayText}
    </span>
  );
};

export default ScrambleText;
